module.exports = __webpack_public_path__ + "static/media/20-7.76fb81e1.mp3";